module.exports = __webpack_public_path__ + "../resources/img/ic_in_progress_number_2.f5a4e392.svg";